var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{attrs:{"chart-data":_vm.chartData,"options":_vm.options,"height":200,"width":1036}})}
var staticRenderFns = []

export { render, staticRenderFns }